// ゲーム機画面内の情報ダイアログ（確定デザイン）。OKひとつ。ヒント等の情報表示用。
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { InScreenModal } from "./ScreenModal";
import { BuilderModalPanel, BuilderModalAccent } from "./BuilderModalPanel";
import { PillSize, PillColor, BuilderPillButton } from "./BuilderPillButton";

const OK_BTN: Record<BuilderModalAccent, PillColor> = {
  [BuilderModalAccent.GREEN]: PillColor.GREEN,
  [BuilderModalAccent.BLUE]: PillColor.BLUE,
  [BuilderModalAccent.BROWN]: PillColor.GREEN,
  [BuilderModalAccent.DANGER]: PillColor.RED,
  [BuilderModalAccent.ORANGE]: PillColor.ORANGE,
};

export const BuilderInfoDialog = ({
  visible,
  title,
  message,
  close,
  accent = BuilderModalAccent.BLUE,
  icon = "lightbulb",
}: {
  visible: boolean;
  title: string;
  message: string;
  close: () => void;
  accent?: BuilderModalAccent;
  icon?: string;
}) => {
  const play = usePlaySound();
  const handleClose = () => {
    play();
    btnDelay(() => close());
  };

  return (
    <InScreenModal open={visible} onBackdropClose={close}>
      <BuilderModalPanel accent={accent} icon={icon} title={title} width={480}>
        <div className="flex-col-el items-start w-full">
          {message?.split("\n").map((line, index) => (
            <p key={index} className="type-text-left type-body text-textcolor-black mb-2">
              {line}
            </p>
          ))}
        </div>

        <div className="flex-row-el flex-center justify-end w-full px-4 pb-2">
          <BuilderPillButton
            color={OK_BTN[accent]}
            size={PillSize.MD}
            icon="close"
            label={I18n.t("MSG_CLOSE_BTN")}
            onClick={handleClose}
          />
        </div>
      </BuilderModalPanel>
    </InScreenModal>
  );
};
